module.exports = __webpack_public_path__ + "static/media/logo-with-label.a1b6379a.svg";